import { authConfig } from '../../auth/authConfig';
import { v4 as uuidv4 } from 'uuid';

const siteName = authConfig.SITE_NAME;
const relativePath = authConfig.RELATIVE_PATH

export const uploadStudentFile = async (bytePdf, fileName, parentfolderpath, fileType, studentId, setErrorfromsp, setloadingActive, setFileuploaded, accessToken) => {
    const filewithtype =  'Consent Form - ' + studentId + '.pdf'
    try{
        setFileuploaded(false);
        if(fileType == null){
            setErrorfromsp("Please select any Document type.")
        } else {
        setloadingActive(true);
        const token = accessToken
        /**Api Request after get Token */
        const getSiteIdurl = "https://graph.microsoft.com/v1.0/sites/" + siteName + ":/" + relativePath;
        const getsite = await fetch(getSiteIdurl, {
            method: "GET",
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        })
        let siteResponse = await getsite.json()
        if(siteResponse?.error){
            setErrorfromsp(siteResponse?.error?.message)
            setloadingActive(false)
        }
        let siteID = siteResponse.id       
        /**Get Drive id of the folder */   
        const getLibraryIdurl = "https://graph.microsoft.com/v1.0/sites/" + siteID + "/drives"
        const getLibraryId = await fetch(getLibraryIdurl, {
            method: "GET",
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        })
        let libraryResponse = await getLibraryId.json()
        if(libraryResponse?.error){
            setErrorfromsp(libraryResponse?.error?.message)
            setloadingActive(false)
        }
        let finddriveid = libraryResponse?.value?.filter((data) => data.name === "Student Documents")
        let driveId = finddriveid?.[0]?.id
        /**Upload student file */                       
        const uploadUrl = "https://graph.microsoft.com/v1.0/sites/" + siteID + "/drives/" + driveId + "/items/root:/" + parentfolderpath + "/" + filewithtype + ":/content"
        const uploadfile = await fetch(uploadUrl, {
            method: "PUT",
            muteHttpExceptions: true,
            body: bytePdf,
            headers: {
                'Authorization': token,
                'Content-Type': 'application/pdf'
            },
        })
        const fileuploadRes = await uploadfile.json()
        if(fileuploadRes?.error){
            setErrorfromsp(fileuploadRes?.error?.message)
            setloadingActive(false)
        }
        /**Upload meta data of file means other columns that relevant the files */
        const uploadMetaDataUrl = "https://graph.microsoft.com/v1.0/sites/" + siteID + "/drives/" + driveId + "/items/root:/" + parentfolderpath + "/" + filewithtype + ":/listItem/fields";
        const payload = {
            StudentID: studentId,
            Documenttype: fileType
        }
        const uploadMetaData = await fetch(uploadMetaDataUrl, {
            method: "PATCH",
            body: JSON.stringify(payload),
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            },
        })
        return uploadMetaData
        }
    } catch (err) {
        console.error(err);
    }
}